(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alone-world-portal"] && !Shopify.designMode) return;
  try {
    
  function startAloneWorldMotion() {
    const hero = document.querySelector('.awp__hero');
    if (!hero || hero.dataset.motionReady === 'true') return;
    hero.dataset.motionReady = 'true';

    const video = hero.querySelector('.awp__hero-video');
    const toggle = hero.querySelector('.awp__motion-toggle');
    const cinematicPlaybackRate = 1;
    video.defaultPlaybackRate = cinematicPlaybackRate;
    video.playbackRate = cinematicPlaybackRate;
    video.play().catch(() => {});

    toggle.addEventListener('click', () => {
      const paused = toggle.getAttribute('aria-pressed') === 'true';
      if (paused) {
        video.playbackRate = cinematicPlaybackRate;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');
      toggle.textContent = paused ? 'Pause motion' : 'Play motion';
    });
  }

  startAloneWorldMotion();
  document.addEventListener('shopify:section:load', startAloneWorldMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloud-girls-eyebrow-final"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const forceCloudEyebrow = () => {
      const eyebrow = document.querySelector('.lore-record--lore-cloud-girls .lore-record__hero-copy > p');
      if (!eyebrow) return;

      eyebrow.style.setProperty('color', '#fffaf2', 'important');
      eyebrow.style.setProperty('font-weight', '800', 'important');
      eyebrow.style.setProperty('-webkit-text-stroke', '.8px rgba(4, 7, 11, 1)', 'important');
      eyebrow.style.setProperty('text-shadow', '0 1px 1px rgba(0,0,0,1), 0 2px 4px rgba(0,0,0,1), 0 0 9px rgba(0,0,0,1), 0 0 18px rgba(0,0,0,.98), 0 0 30px rgba(0,0,0,.9)', 'important');
    };

    forceCloudEyebrow();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', forceCloudEyebrow, { once: true });
    document.addEventListener('shopify:section:load', forceCloudEyebrow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["final-mobile-a11y-fix"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const apply = () => {
      const worldDistricts = document.querySelector('.lore-world__district-art img');
      if (worldDistricts) worldDistricts.alt = 'The districts of Arnemaelia: Vriska, Boima, Ethra and Calera';

      const cloudDistricts = document.querySelector('.lore-record--lore-cloud-girls .lore-record__figure img');
      if (cloudDistricts) cloudDistricts.alt = 'The districts of Arnemaelia: Vriska, Boima, Ethra and Calera';
    };

    apply();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["final-render-fix"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const repairFinalJxinieImages = () => {
      const source = document.querySelector('.final-render-fix');
      const record = document.querySelector('.lore-record--lore-jxinie-glowbulbs');
      if (!source || !record) return false;

      const data = source.dataset;
      const map = new Map([
        ['A Jxinie adapted to life beyond its makers', data.jxinieAlien],
        ['A Jxinie showing its handmade and organic history', data.jxinieConstructed],
        ['A Jxinie adapted to life in the wild', data.jxinieAlien],
        ['A Jxinie shaped by generations of adaptation', data.jxinieElegant],
        ['Glowbulbs sustaining the environment around Jxinie', data.glowbulb]
      ]);

      let repaired = 0;
      record.querySelectorAll('.lore-record__body img').forEach((img) => {
        const url = map.get((img.getAttribute('alt') || '').trim());
        if (!url) return;
        if (img.getAttribute('src') !== url) img.setAttribute('src', url);
        img.removeAttribute('srcset');
        repaired += 1;
      });

      return repaired >= 5;
    };

    const runRepair = () => {
      if (repairFinalJxinieImages()) return;

      const record = document.querySelector('.lore-record--lore-jxinie-glowbulbs');
      if (!record) return;

      const observer = new MutationObserver(() => {
        if (repairFinalJxinieImages()) observer.disconnect();
      });

      observer.observe(record, { childList: true, subtree: true });

      /* Safety retries cover delayed section/canon scripts without keeping the observer alive forever. */
      [50, 150, 350, 700, 1200].forEach((delay) => {
        window.setTimeout(() => {
          if (repairFinalJxinieImages()) observer.disconnect();
        }, delay);
      });

      window.setTimeout(() => observer.disconnect(), 2500);
    };

    runRepair();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runRepair, { once: true });
    }
    document.addEventListener('shopify:section:load', runRepair);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lore-content-fix"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fixWorld = () => {
      const world = document.querySelector('.lore-world');
      if (!world) return;

      const districtLabel = world.querySelector('.lore-world__districts');
      if (districtLabel) districtLabel.textContent = 'THE FOUR DISTRICTS OF ARNEMAELIA';
      const districtArt = world.querySelector('.lore-world__district-art img');
      if (districtArt) districtArt.alt = 'The districts of Arnemaelia: Vriska, Baiama, Ithra and Calira';

      const riftProse = world.querySelector('.lore-world__rift-grid .lore-world__prose');
      if (riftProse) riftProse.innerHTML = `
        <p>The Rift is not simply a canyon dividing Oti-Zahruhl. It is the pressure seam where two realities continue to overlap.</p>
        <p>Near it, laws weaken. Distances contract. Aether becomes volatile. Fragments of land lift free from gravity and remain suspended in invisible currents.</p>
        <p>Ancient temples stand where the realities touch most closely. Some are believed to connect with the Nexus beneath the Rift.</p>
        <p>Whether those temples are gateways, locks or warnings remains disputed.</p>`;

      const cloudFeature = Array.from(world.querySelectorAll('.lore-world__feature')).find((item) => item.querySelector('a[href="/pages/lore-cloud-girls"]'));
      if (cloudFeature) {
        cloudFeature.querySelectorAll('p').forEach((p) => {
          if (p.textContent.includes('If an Aetherkin chooses her')) {
            p.textContent = 'If the bond is ready, the Aetherkin catches her. If it is not, she is returned safely to try again. That freedom is what gives the moment meaning.';
          }
        });
      }

      const duch8Feature = Array.from(world.querySelectorAll('.lore-world__feature')).find((item) => item.querySelector('a[href="/pages/lore-duch8"]'));
      const duch8Copy = duch8Feature?.lastElementChild;
      if (duch8Copy) duch8Copy.innerHTML = `
        <p class="lore-world__number">02</p>
        <h3>DUCH8</h3>
        <p>DUCH8 is not merely a facility. It is a process, culture and belief system built around sacred reconstruction.</p>
        <p>Its people reject the idea that an original body is automatically the truest body. Organic tissue, adaptive armour, engineered nerves, mechanical limbs, memory structures and living materials may all become part of one continuing person.</p>
        <p>There is no standard model. Every reconstruction is shaped by anatomy, survival, history, purpose and the meaning assigned to what has been lost.</p>
        <p>They do not worship machinery. Pain is not the purpose. The purpose is not replacement, but continued becoming.</p>
        <p class="lore-world__closing">To be unfinished<br>is to remain in motion.</p>
        <a class="lore-world__button" href="/pages/lore-duch8">Open the DUCH8 record</a>`;

      const chains = world.querySelector('.lore-world__chains-inner');
      if (chains) chains.innerHTML = `
        <p class="lore-world__eyebrow">The Plateaus of Elion</p>
        <h2>The Living Chains</h2>
        <p>The Living Chains guard the Plateaus of Elion: sacred grounds connected with containment, transformation and trial.</p>
        <p>The Chains are living beings or living systems, not ordinary restraints. Their purpose cannot be reduced to imprisonment.</p>
        <p>Their origin, hierarchy, individual abilities and exact relationship to Zahruhlian balance, the Rift and Nexus pressure remain beyond this introductory record.</p>
        <a class="lore-world__button" href="/pages/lore-living-chains-elion">Open the Living Chains record</a>`;

      const ranks = world.querySelector('.lore-world__rank-grid');
      if (ranks) ranks.innerHTML = `
        <div><span>01</span><strong>Containment</strong><p>Elion holds forces and knowledge that cannot always be destroyed safely.</p></div>
        <div><span>02</span><strong>Transformation</strong><p>The Plateaus are sacred grounds where transformation forms part of the record.</p></div>
        <div><span>03</span><strong>Trial</strong><p>Trial belongs to Elion, though its deeper rites remain unresolved in this archive.</p></div>
        <div><span>04</span><strong>Guardianship</strong><p>The Living Chains guard the Plateaus. They are living systems, not ordinary restraints.</p></div>`;

      const pressure = world.querySelector('.lore-world__pressure');
      if (pressure) {
        const heading = pressure.querySelector('.lore-world__pressure-visual h2');
        if (heading) heading.textContent = 'Balance is not given';
        const prose = pressure.querySelector('.lore-world__prose');
        if (prose) prose.innerHTML = `
          <p>Oti-Zahruhl survives because neither reality has defeated the other.</p>
          <p>One side exists beneath endless radiance: living cities, abundant Aether, bright storms and landscapes shaped by growth. The other exists beneath immense shadow: ancient memory, deep currents, night-bound structures and forms of life that do not require light to recognise one another.</p>
          <p>The Rift keeps those pressures in contact. The world remains whole only through constant correction between forces that could otherwise destroy one another.</p>
          <p class="lore-world__pullquote">Balance is not stillness.<br>It is maintained.</p>`;
      }

      const figures = world.querySelector('.lore-world__figures');
      if (figures) figures.innerHTML = `
        <div><strong>≈ 20%</strong><span>of the known world has probably been explored</span></div>
        <div><strong>&lt; 20%</strong><span>of lesser-known and unknown regions has been meaningfully charted</span></div>
        <div><strong>≈ 0%</strong><span>of the wider galaxy, universe and realms beyond has been explored</span></div>
        <div><strong>No final map</strong><span>because discovery is part of building the world</span></div>`;
    };

    const fixRecord = () => {
      const record = document.querySelector('.lore-record');
      if (!record) return;
      const handle = window.location.pathname.split('/').filter(Boolean).pop();
      const heroEyebrow = record.querySelector('.lore-record__hero-copy > p');
      const heroLead = record.querySelector('.lore-record__hero-copy > span');
      const body = record.querySelector('.lore-record__body');

      if (handle === 'lore-cloud-girls') {
        const districtFigure = record.querySelector('.lore-record__figure');
        const districtCaption = districtFigure?.querySelector('figcaption');
        const districtImage = districtFigure?.querySelector('img');
        if (districtCaption) districtCaption.textContent = 'THE FOUR DISTRICTS OF ARNEMAELIA';
        if (districtImage) districtImage.alt = 'The districts of Arnemaelia: Vriska, Baiama, Ithra and Calira';
      }

      if (handle === 'lore-duch8') {
        if (heroEyebrow) heroEyebrow.textContent = 'Sacred reconstruction · Continued becoming';
        if (heroLead) heroLead.textContent = 'A culture, process and philosophy that honours what remains and gives reconstruction meaning.';
        const first = body?.querySelector('.lore-record__article');
        if (first) {
          const eyebrow = first.querySelector('.lore-record__eyebrow');
          const heading = first.querySelector('h2');
          const prose = first.querySelector('.lore-record__prose');
          if (eyebrow) eyebrow.textContent = 'A culture of reconstruction';
          if (heading) heading.innerHTML = 'Not replacement.<br>Continued becoming.';
          if (prose) prose.innerHTML = `
            <p>DUCH8 is a process, culture and belief system built around reconstruction.</p>
            <p>Its people reject the idea that an original body is automatically the truest body. Every reconstruction is shaped by anatomy, survival, history, purpose and the meaning assigned to what has been lost.</p>
            <p>Organic tissue, adaptive armour, engineered nerves, mechanical limbs, memory structures and living materials may all become part of one continuing person.</p>
            <p>They do not worship machinery or perfection. They honour continued becoming.</p>`;
        }
      }

      if (handle === 'lore-living-chains-elion' && body) {
        if (heroEyebrow) heroEyebrow.textContent = 'The Plateaus of Elion · Containment · Transformation · Trial';
        if (heroLead) heroLead.textContent = 'Living guardians of sacred ground. Their purpose cannot be reduced to imprisonment.';
        body.innerHTML = `
          <article class="lore-record__article">
            <div><p class="lore-record__eyebrow">Confirmed record</p><h2>The Plateaus of Elion</h2><figure class="lore-record__article-side"><img src="{{ 'living-chains-network.png' | asset_url }}" alt="Living Chains visual archive record at the Plateaus of Elion" width="1536" height="1024" loading="lazy"></figure></div>
            <div class="lore-record__prose"><p>The Living Chains guard the Plateaus of Elion.</p><p>The Plateaus are sacred grounds connected with containment, transformation and trial. The Chains are living beings or living systems, not ordinary restraints.</p><p>Their purpose must not be reduced to imprisonment. Elion exists where protection, preservation, restraint and transformation cannot be treated as the same thing.</p></div>
          </article>
          <div class="lore-record__gallery lore-record__gallery--chains" aria-label="Living Chains visual archive records">
            <figure><img src="{{ 'living-chains-network.png' | asset_url }}" alt="Living Chains visual archive record one" width="1536" height="1024" loading="lazy"><figcaption>Elion · field record</figcaption></figure>
            <figure><img src="{{ 'elion-living-chains.png' | asset_url }}" alt="Living Chains visual archive record two" width="1536" height="1024" loading="lazy"><figcaption>Guardianship · field record</figcaption></figure>
            <figure class="lore-record__gallery-symbol"><img src="{{ 'living-chains-sigil.png' | asset_url }}" alt="Living Chains faction symbol" width="1024" height="1024" loading="lazy"><figcaption>Faction mark</figcaption></figure>
          </div>
          <div class="lore-record__statement">Their purpose cannot be reduced<br>to imprisonment.</div>
          <div class="lore-record__ranks"><div><span>01</span><h3>Containment</h3><p>Elion holds forces and knowledge that cannot always be destroyed safely.</p></div><div><span>02</span><h3>Transformation</h3><p>The Plateaus are sacred grounds where transformation forms part of the record.</p></div><div><span>03</span><h3>Trial</h3><p>Trial belongs to Elion, though its deeper rites remain unresolved here.</p></div><div><span>04</span><h3>Guardianship</h3><p>The Living Chains guard the Plateaus as living beings or living systems.</p></div></div>
          <article class="lore-record__article lore-record__article--reverse">
            <div><p class="lore-record__eyebrow">Unresolved record</p><h2>What remains unwritten</h2><figure class="lore-record__article-side"><img src="{{ 'elion-living-chains.png' | asset_url }}" alt="Living Chains visual archive record" width="1536" height="1024" loading="lazy"></figure></div>
            <div class="lore-record__prose"><p>Their origin, hierarchy, named individuals and specific abilities are not assigned here without the dedicated Living Chains source.</p><p>Their exact relationship to Zahruhlian balance, the Rift and Nexus pressure also remains to be established from that record.</p><p>The archive knows what they guard. It does not pretend to know more.</p></div>
          </article>`;
      }
    };

    const apply = () => {
      fixWorld();
      fixRecord();
    };

    apply();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lore-media-fix"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setImage = (img, url) => {
      if (!img || !url) return;
      img.setAttribute('src', url);
      img.removeAttribute('srcset');
    };

    const apply = () => {
      const data = document.querySelector('.lore-media-fix')?.dataset;
      if (!data) return;

      document.querySelectorAll('.lore-record--lore-jxinie-glowbulbs img').forEach((img) => {
        const alt = (img.getAttribute('alt') || '').trim();
        if (alt === 'A Jxinie adapted to life beyond its makers') setImage(img, data.jxinieAlien);
        if (alt === 'A Jxinie showing its handmade and organic history') setImage(img, data.jxinieConstructed);
        if (alt === 'A Jxinie adapted to life in the wild') setImage(img, data.jxinieAlien);
        if (alt === 'A Jxinie shaped by generations of adaptation') setImage(img, data.jxinieElegant);
        if (alt === 'Glowbulbs sustaining the environment around Jxinie') setImage(img, data.glowbulb);
        if (alt === 'Jxinie visual archive record') setImage(img, data.jxinieAlien);
        if (alt === 'Jxinie visual archive record one') setImage(img, data.jxinieConstructed);
        if (alt === 'Jxinie visual archive record two') setImage(img, data.jxinieAlien);
        if (alt === 'Jxinie visual archive record three') setImage(img, data.jxinieElegant);
        if (alt === 'Glowbulb visual archive record') setImage(img, data.glowbulb);
      });

      document.querySelectorAll('.lore-record--lore-living-chains-elion img').forEach((img) => {
        const alt = (img.getAttribute('alt') || '').trim();
        if (alt === 'Living Chains visual archive record at the Plateaus of Elion') setImage(img, data.chainsNetwork);
        if (alt === 'Living Chains visual archive record one') setImage(img, data.chainsNetwork);
        if (alt === 'Living Chains visual archive record two') setImage(img, data.chainsElion);
        if (alt === 'Living Chains faction symbol') setImage(img, data.chainsSigil);
        if (alt === 'Living Chains visual archive record') setImage(img, data.chainsElion);
        if (alt === 'Living Chains guardians among the golden Plateaus of Elion') setImage(img, data.chainsElion);
        if (alt === 'Living chains crossing between glyph-marked plateaus') setImage(img, data.chainsNetwork);
      });
    };

    const settle = () => {
      apply();
      requestAnimationFrame(() => requestAnimationFrame(apply));
      setTimeout(apply, 80);
    };

    settle();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', settle, { once: true });
    document.addEventListener('shopify:section:load', settle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-finish-fix"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const source = () => document.querySelector('.site-finish-fix');
    const setImage = (img, url, alt) => {
      if (!img || !url) return;
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      if (alt) img.setAttribute('alt', alt);
    };

    const repairCloudGirls = () => {
      const data = source()?.dataset;
      if (!data?.cloudMovement || !data?.cloudOffEdge) return;
      const record = document.querySelector('.lore-record--lore-cloud-girls');
      const articles = record?.querySelectorAll('.lore-record__article');

      setImage(record?.querySelector('.lore-record__hero-media > img'), data.cloudMovement, 'A Cloud Girl moving through Arnemaelia with an Aetherkin companion');
      setImage(articles?.[0]?.querySelector('.lore-record__article-side img'), data.cloudMovement, 'A Cloud Girl moving through Arnemaelia with an Aetherkin companion');
      setImage(articles?.[1]?.querySelector('.lore-record__article-side img'), data.cloudOffEdge, 'A Cloud Girl going Off the Edge as an Aetherkin chooses to meet her');
      setImage(document.querySelector('.lore-world__path[href="/pages/lore-cloud-girls"] .lore-world__path-media img'), data.cloudMovement, 'A Cloud Girl moving through Arnemaelia with an Aetherkin companion');

      const cloudFeature = Array.from(document.querySelectorAll('.lore-world__feature')).find((feature) => feature.querySelector('a[href="/pages/lore-cloud-girls"]'));
      setImage(cloudFeature ? Array.from(cloudFeature.children).find((node) => node.tagName === 'IMG') : null, data.cloudOffEdge, 'A Cloud Girl going Off the Edge above Arnemaelia');
    };

    const repairLivingChains = () => {
      const data = source()?.dataset;
      const record = document.querySelector('.lore-record--lore-living-chains-elion');
      if (!record || !data) return;
      const articles = record.querySelectorAll('.lore-record__article');
      setImage(articles[0]?.querySelector('.lore-record__article-side img'), data.chainsElion, 'Living Chains guardians among the golden Plateaus of Elion');
      setImage(articles[1]?.querySelector('.lore-record__article-side img'), data.chainsNetwork, 'Living chains crossing between glyph-marked plateaus');
    };

    const repairLegacyBrokenMedia = () => {
      const data = source()?.dataset;
      if (!data) return;
      document.querySelectorAll('.lore-record__body img').forEach((img) => {
        const alt = (img.getAttribute('alt') || '').trim();
        if (alt === 'Jxinie visual archive record') setImage(img, data.jxinieAlien);
        if (alt === 'Jxinie visual archive record one') setImage(img, data.jxinieConstructed);
        if (alt === 'Jxinie visual archive record two') setImage(img, data.jxinieAlien);
        if (alt === 'Jxinie visual archive record three') setImage(img, data.jxinieElegant);
        if (alt === 'Glowbulb visual archive record') setImage(img, data.glowbulb);
        if (alt === 'Living Chains visual archive record at the Plateaus of Elion') setImage(img, data.chainsElion);
        if (alt === 'Living Chains visual archive record one') setImage(img, data.chainsNetwork);
        if (alt === 'Living Chains visual archive record two') setImage(img, data.chainsElion);
        if (alt === 'Living Chains faction symbol') setImage(img, data.chainsSigil);
        if (alt === 'Living Chains visual archive record') setImage(img, data.chainsElion);
      });
    };

    const repairJxinieCanon = () => {
      const world = document.querySelector('.lore-world');
      if (world) {
        const path = Array.from(world.querySelectorAll('.lore-world__path')).find((card) => card.querySelector('strong')?.textContent.trim() === 'Jxinie');
        const pathLabel = path?.querySelector('.lore-world__path-copy span');
        if (pathLabel) pathLabel.textContent = 'Handmade life · Adaptation · Glowbulbs';

        const feature = Array.from(world.querySelectorAll('.lore-world__feature')).find((item) => item.querySelector('a[href="/pages/lore-jxinie-glowbulbs"]'));
        const copy = feature?.lastElementChild;
        if (copy) {
          copy.innerHTML = `
            <p class="lore-world__number">03</p>
            <p class="lore-world__eyebrow">Handmade life · Adaptation · Glowbulbs</p>
            <h3>Jxinie &amp; the Glowbulbs</h3>
            <p>Jxinie began as handmade life — created and brought to life rather than born into an established natural lineage.</p>
            <p>They did not remain dependent on their makers. Over time they adapted, evolved and survived in the wild. Life found a way.</p>
            <p>Glowbulbs became central to that survival. Jxinie draw their water, sustenance and everything they need to live from them.</p>
            <p>Glowbulbs are everywhere across the environments Jxinie inhabit. So are the Jxinie.</p>
            <p class="lore-world__closing">Made by hand.<br>Changed by life.</p>
            <a class="lore-world__button" href="/pages/lore-jxinie-glowbulbs">Open the Jxinie record</a>`;
        }
      }

      const record = document.querySelector('.lore-record--lore-jxinie-glowbulbs');
      if (!record) return;
      const heroEyebrow = record.querySelector('.lore-record__hero-copy > p');
      const heroLead = record.querySelector('.lore-record__hero-copy > span');
      const body = record.querySelector('.lore-record__body');

      if (heroEyebrow) heroEyebrow.textContent = 'Handmade life · Adaptation · Glowbulbs';
      if (heroLead) heroLead.textContent = 'Brought to life by hand, then changed by the world. Jxinie survived, evolved and spread wherever Glowbulbs could sustain them.';

      if (body) {
        body.innerHTML = `
          <article class="lore-record__article">
            <div>
              <p class="lore-record__eyebrow">Where they began</p>
              <h2>Made by hand.<br>Changed by life.</h2>
              <figure class="lore-record__article-side lore-record__article-side--portrait">
                <img src="{{ 'jxinie-alien-form.png' | asset_url }}" alt="A Jxinie adapted to life beyond its makers" width="1024" height="1024" loading="lazy">
              </figure>
            </div>
            <div class="lore-record__prose">
              <p>Jxinie began as handmade life. They were created, assembled and brought to life.</p>
              <p>What followed was not planned forever by the hands that first made them. Over time Jxinie adapted, evolved and survived in the wild.</p>
              <p>Life found a way.</p>
            </div>
          </article>
          <div class="lore-record__gallery lore-record__gallery--jxinie" aria-label="Jxinie visual records">
            <figure><img src="{{ 'jxinie-constructed-organic.png' | asset_url }}" alt="A Jxinie showing its handmade and organic history" width="1024" height="1536" loading="lazy"><figcaption>Handmade origins</figcaption></figure>
            <figure><img src="{{ 'jxinie-alien-form.png' | asset_url }}" alt="A Jxinie adapted to life in the wild" width="1024" height="1024" loading="lazy"><figcaption>Life found a way</figcaption></figure>
            <figure><img src="{{ 'jxinie-elegant-form.png' | asset_url }}" alt="A Jxinie shaped by generations of adaptation" width="1024" height="1536" loading="lazy"><figcaption>Adaptation over time</figcaption></figure>
          </div>
          <div class="lore-record__statement">They were brought to life.<br>Then life carried on.</div>
          <article class="lore-record__article lore-record__article--reverse">
            <div>
              <p class="lore-record__eyebrow">The Glowbulbs</p>
              <h2>Everything they need.</h2>
              <figure class="lore-record__article-side">
                <img src="{{ 'glowbulb-forest-house.png' | asset_url }}" alt="Glowbulbs sustaining the environment around Jxinie" width="1536" height="1024" loading="lazy">
              </figure>
            </div>
            <div class="lore-record__prose">
              <p>Glowbulbs are the foundation of Jxinie survival.</p>
              <p>Their water, sustenance and everything they need to live comes from the Glowbulbs.</p>
              <p>Glowbulbs are everywhere. So are the Jxinie.</p>
            </div>
          </article>`;
      }
    };

    const apply = () => {
      repairCloudGirls();
      repairLivingChains();
      repairLegacyBrokenMedia();
      repairJxinieCanon();
    };

    apply();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();
})();
